import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { folderTypes } from "@redotech/redo-views-common/folders";
import { RecycleView } from "@redotech/redo-views-common/views";
import { ReactNode, createContext, memo } from "react";
import { useRecordViews } from "../../return/views/record-views-query";

export const RecycleViewsContext = createContext<
  | {
      teamViews?: RecycleView[];
      folders?: folderTypes["recycle"][];
      reloadViews?: () => Promise<void>;
    }
  | undefined
>(undefined);

export const ReloadRecycleViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const RecycleViewsProvider = memo(function RecycleViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useRecordViews(
    ReturnTypeEnum.RECYCLE,
    ReturnsAndClaimsPermissions.MANAGE_RECYCLING_REQUESTS,
  );

  return (
    <RecycleViewsContext.Provider
      value={{ teamViews: views, folders, reloadViews }}
    >
      <ReloadRecycleViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadRecycleViewsContext.Provider>
    </RecycleViewsContext.Provider>
  );
});
